import { CommentRichTextPreviewer } from '@exam-management/qset-review-subtask-details';
import { Flex, ReadonlyField, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { type QuestionSubTaskComment } from '../../types';

interface CommentProps {
  comment: QuestionSubTaskComment;
}
export default function Comment(props: Readonly<CommentProps>) {
  const { comment } = props;
  const { content, createdAt, taskId, user } = comment;
  const author = `${user.firstname} ${user.lastname}`;
  return (
    <ReadonlyField
      content={
        <Flex sx={{ gap: (theme) => theme.spacing(3), flexDirection: 'column' }}>
          <Flex sx={{ gap: (theme) => theme.spacing(2), alignItems: 'center' }}>
            <Text variant='body1Semibold'>{author}</Text>
            <Text variant='body2' color='textSecondary'>
              {formatDateTime(new Date(createdAt))}
            </Text>
          </Flex>
          <CommentRichTextPreviewer content={content} taskId={taskId} />
        </Flex>
      }
    />
  );
}
